import React, { useEffect, useState } from 'react';
import { usePaginacion, Paginacion, PiePagina } from '../../../Helpers/importacionesComunes'
import { } from '@fortawesome/free-regular-svg-icons';
import { faSearchDollar, faWindowClose, faSort } from '@fortawesome/free-solid-svg-icons';
import { useContextoGlobal } from '../../../Context/contextoGlobal'
import { TotalImportes } from '../../ComponentesComunes/TotalImportes'
import Excel from '../../../componentes/Excel'
import { Card, CardBody, Typography, Button, Tooltip, IconButton } from '@material-tailwind/react';
import { ChevronUpDownIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid';
import ExportToExcelGeneric from '../../../componentes/exportExcelGeneric';
import { NavLink } from 'react-router-dom';

const columnas = [{ label: 'Fecha', value: 'fecha' },
{ label: 'Sucursal', value: 'sucurscal_bco' },
{ label: 'Concepto', value: 'concepto' },
{ label: 'Estado', value: 'estado' },
{ label: 'Monto', value: 'importe_numerico' }]

const TablaBase = ({ registrosAmostrar, onEditarRegistro, onEliminarRegistro, puedeEditarRegistro = () => true }) => {

    const { configuracion, paginar, inicializar: inicializarPaginacion } = usePaginacion()
    // Hago una copia de los datos que se reciben para manejar el ordenamiento
    const [copiaRegistrosaMostrar, setCopiaRegistrosaMostrar] = useState([...registrosAmostrar])
    const [orden, setOrden] = useState(null)
    const [nuevoCampo, setNuevoCampo] = useState(true)
    const [contadorOrden, setContadorOrden] = useState(0)
    const { usuario } = useContextoGlobal()


    useEffect(() => {
        setCopiaRegistrosaMostrar([...registrosAmostrar])
        inicializarPaginacion(null, registrosAmostrar)
    }, [registrosAmostrar])


    useEffect(() => {// el ordenamiento se maneja con las propiedades orden que almacena el campo por el cual ordenar
        // y nuevoCampo que es un flag que indica si es otro campo o el mismo a la inversa
        // cada vez que se cambia el orden en click de la cabecera se cambia contadorOrden como un trigger 

        ordenarDatos()
    }, [contadorOrden])

    const ordenarDatos = () => {
        setCopiaRegistrosaMostrar([...registrosAmostrar.sort((a, b) => { return comparacion(a, b) })
        ])
    }

    const funcionOrden = (nombre_campo) => {

        if (orden == nombre_campo) {
            setNuevoCampo(false)
        } else {
            setNuevoCampo(true)
        }

        setOrden(nombre_campo)
        setContadorOrden(contadorOrden + 1)

    }

    const comparacion = (a, b) => {

        switch (orden) {
            case null: return 0
            case 'id_region':
            case 'edad':

                if (nuevoCampo == true) {
                    return a[orden] - b[orden]
                } else {
                    if (contadorOrden % 2 == 0) {
                        return b[orden] - a[orden]
                    } else {
                        return a[orden] - b[orden]
                    }
                }
            case 'ult_ascenso':
            case 'fecha':

                const dia_a = Number(a[orden].substring(0, 2));
                const mes_a = Number(a[orden].substring(3, 5));
                const anio_a = Number(a[orden].substring(6, 10));

                const fa = new Date(anio_a, mes_a, dia_a);

                const dia_b = Number(b[orden].substring(0, 2));
                const mes_b = Number(b[orden].substring(3, 5));
                const anio_b = Number(b[orden].substring(6, 10));

                const fb = new Date(anio_b, mes_b, dia_b);

                if (nuevoCampo == true) {
                    return fa - fb
                } else {
                    if (contadorOrden % 2 == 0) {
                        return fb - fa
                    } else {
                        return fa - fb
                    }
                }
            default:
                if (nuevoCampo == true) {
                    return a[orden].localeCompare(b[orden])
                } else {
                    if (contadorOrden % 2 == 0) {
                        return b[orden].localeCompare(a[orden])
                    } else {
                        return a[orden].localeCompare(b[orden])
                    }
                }
        }
    }

    const convertirFormato = (numero) => {
        // Reemplaza la coma por un punto
        let numeroConPunto = numero.replace(/,/g, '.');
        // Reemplaza el punto (de los decimales) por una coma
        let numeroEnNuevoFormato = numeroConPunto.replace(/\.(?=[^.]*$)/, ',');
        return numeroEnNuevoFormato;
    }

    
    const formatearImporte = (numero) => {
        return numero.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const obtenerClaveFila = (item) => {
        return String(
            item.id_interdeposito ||
            item.id_interdep ||
            item.id ||
            [item.fecha, item.cod_operativo, item.referencia, item.suc_origen, item.importe_pesos].join('|')
        )
    }

    return <div style={{ marginTop: '1rem' }}>
        {copiaRegistrosaMostrar.length > 0 && <Excel datos={copiaRegistrosaMostrar}
            descripcion='Movimientos'
            columnas={columnas}
            titulo='Interdepósitos' />}
        {copiaRegistrosaMostrar.length > 0 && <div className="flex f-col">
            <div className="flex justify-center gap-2">
                <div>
                    <span className="text-xl">{copiaRegistrosaMostrar.length}</span>
                    <span className="text-large">{copiaRegistrosaMostrar.length == 1 ? ` registro encontrado` : ` registros encontrados`}</span>
                </div>
            </div>
            <div className='font-bold mb-2'>
                <TotalImportes
                    registros={copiaRegistrosaMostrar}
                    callbackQuitarNulos={(item) => { return item.importe_pesos != null }}
                    campoImporte='importe_pesos'
                    campoNumerico='importe_pesos'
                />
            </div>
        </div>}
        {copiaRegistrosaMostrar.length > 0 &&
            <Card className="h-full  rounded-none">
                <div className="w-full flex items-end justify-end pr-3 pb-2">
                    <ExportToExcelGeneric data={copiaRegistrosaMostrar} fileName="Listado de Interdepósitos" isProvider={true}/>
                    <NavLink to="/crear-interdepositos">
                        <Button onClick={() => console.log(11)} variant="outlined" className='ml-2 bg-[#2FB18F] text-white'>
                            Añadir
                        </Button> 
                    </NavLink>
                </div>
                <CardBody className="overflow-scroll-none px-0 pt-0 pb-0">
                    <table className="min-w-max w-full table-auto text-left">
                        <thead>
                            <tr>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Fecha' sort orden={orden === 'fecha'} callback={() => funcionOrden('fecha')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Sucursal' sort orden={orden === 'desc_sucursal'} callback={() => funcionOrden('desc_sucursal')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Concepto' sort orden={orden === 'concepto'} callback={() => funcionOrden('concepto')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Estado' sort orden={orden === 'estado'} callback={() => funcionOrden('estado')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Monto' sort orden={orden === 'importe_pesos'} callback={() => funcionOrden('importe_pesos')} />
                                </th>
                                <th className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 text-center">
                                    <ThTitle title='Acciones' />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {copiaRegistrosaMostrar
                                .filter((item, index) => {
                                    return index >= configuracion.iIni && index <= configuracion.iFin
                                })
                                .map(
                                    (item, index) => {
                                        const isLast = index === copiaRegistrosaMostrar.length - 1;
                                        const classes = isLast
                                            ? "p-4"
                                            : "p-4 border-b border-blue-gray-50";
                                        const puedeEditarItem = puedeEditarRegistro(item)

                                        return (
                                            <tr key={obtenerClaveFila(item)}>
                                                <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal opacity-70"
                                                    >
                                                        {item.fecha}
                                                    </Typography>
                                                </td>
                                                <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.desc_sucursal}
                                                    </Typography>
                                                </td>
                                                <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.concepto}
                                                    </Typography>
                                                </td>
                                                <td className={`${classes}`}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal"
                                                    >
                                                        {item.estado}
                                                    </Typography>
                                                </td>
                                                <td className={classes}>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal text-right"
                                                    >
                                                        {formatearImporte(item.importe_pesos)}
                                                    </Typography>
                                                </td>
                                                <td className={`${classes} text-center`}>
                                                    <div className="flex items-center justify-center gap-1">
                                                        {puedeEditarItem && <span
                                                            onClick={() => onEditarRegistro(item)}
                                                            title="Editar interdepósito"
                                                            className="cursor-pointer text-blue-gray-500 hover:text-blue-gray-700 transition-colors"
                                                        >
                                                            <PencilSquareIcon className="h-6 w-6" />
                                                        </span>}
                                                        <Tooltip content="Eliminar">
                                                            <IconButton variant="text" size="sm" onClick={() => onEliminarRegistro(item)}>
                                                                <TrashIcon className="h-4 w-4 text-gray-900" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                        </tbody>
                    </table>

                    {copiaRegistrosaMostrar.length > 0 &&
                        <PiePagina>
                            <div className="items-center">
                                <Paginacion configuracion={configuracion} paginar={paginar} />
                            </div>
                        </PiePagina>}
                </CardBody>
            </Card>
        }
    </div>
}

const ThTitle = ({ title, sort, orden, callback }) => {
    return <div className='flex f-col justify-center items-center'>
        <Typography
            variant="small"
            color="blue-gray"
            className="flex justify-between gap-2 font-normal leading-none opacity-70"
        >
            {title}{" "}
            {sort &&
                <ChevronUpDownIcon strokeWidth={2} className={`cursor-pointer ${orden ? 'text-blue-500' : ''} h-4 w-4`} icon={faSort} onClick={callback} />
            }
        </Typography>
    </div>
}

export const Tabla = React.memo(TablaBase)